// extracted by mini-css-extract-plugin
export default {"container":"DeveloperListPage_container__mjXf+"};